import { IWeb3ChainType } from './type';
import { Web3Type } from '../../config/type';
import { mockSolEvmChainId } from '../../config/sol';
import { mockBtcEvmChainId } from '../../config/btc';
import { mockTonChainId } from '../../config/ton';

export const getChainId = (chain: IWeb3ChainType | undefined) => {
  if (chain?.chain?.id) {
    return chain?.chain?.id;
  }
  if (chain?.type === Web3Type.SOL) {
    return mockSolEvmChainId;
  }
  if (chain?.type === Web3Type.BTC) {
    return mockBtcEvmChainId;
  }
  if (chain?.type === Web3Type.TON) {
    return mockTonChainId;
  }
  return chain?.chain?.id;
};
